import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor(private auth: AuthService) {}

  private static readonly SYMBOLS: Record<string, string> = {
    BRL: 'R$', MXN: 'MX$', CLP: '$', PEN: 'S/', COP: '$', PHP: '₱'
  };
  private static readonly LOCALES: Record<string, string> = {
    BRL: 'pt-BR', MXN: 'es-MX', CLP: 'es-CL', PEN: 'es-PE', COP: 'es-CO', PHP: 'en-PH'
  };


  get code(): string {
    return this.auth.getOriginCurrency();
  }
  get symbol(): string {
    return CurrencyService.SYMBOLS[this.code] ?? this.code;
  }
  get locale(): string {
    return CurrencyService.LOCALES[this.code] ?? 'pt-BR';
  }

  getLocaleFor(code: string | null | undefined): string {
    const c = (code || this.code || 'BRL').toUpperCase();
    return CurrencyService.LOCALES[c] ?? 'pt-BR';
  }

}

